import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

export const SuperAdminNav = React.forwardRef<HTMLDivElement>((_props, ref) => {
  const location = useLocation();
  const { theme } = useTheme();

  console.log(`%c[SuperAdminNav] Renderizou. Pathname: ${location.pathname}`, 'color: #00aaff');
  
  const navItems = [
    {
      path: '/superadmin',
      label: '📊 Dashboard Analytics',
      icon: '📊'
    },
    {
      path: '/superadmin/empresas',
      label: '🏢 Empresas',
      icon: '🏢'
    },
    {
      path: '/superadmin/plataformas',
      label: '🌐 Plataformas',
      icon: '🌐'
    },
    {
      path: '/superadmin/tooltips',
      label: '💬 Tooltips',
      icon: '💬'
    },
    {
      path: '/superadmin/usuarios',
      label: '👥 Usuários',
      icon: '👥'
    },
    {
      path: '/superadmin/integracoes',
      label: '🔗 Integrações',
      icon: '🔗'
    },
    {
      path: '/superadmin/ia',
      label: '🤖 IA',
      icon: '🤖'
    },
    {
      path: '/superadmin/analytics-tenants',
      label: '📈 Analytics Tenants',
      icon: '📈'
    },
    {
      path: '/superadmin/configuracoes',
      label: '⚙️ Configurações Gerais',
      icon: '⚙️'
    },
    {
      path: '/superadmin/aparencia',
      label: '🎨 Aparência',
      icon: '🎨'
    },
    {
      path: '/superadmin/backup',
      label: '💾 Backup',
      icon: '💾'
    }
  ];

  const isActive = (path: string) => {
    // Caso especial para a raiz /superadmin (evitar que sub-rotas ativem o link)
    if (path === '/superadmin') {
      return location.pathname === '/superadmin' || location.pathname === '/superadmin/analytics-dashboard';
    }
    // Para outros paths, verificar se a URL começa com o path (suporta sub-rotas)
    return location.pathname.startsWith(path);
  };

  return (
    <div 
      ref={ref}
      className="shadow-sm border-b mb-6"
      style={{
        backgroundColor: 'var(--bg-card)',
        borderColor: 'var(--border-color)'
      }}
    >
      <div className="px-6">
        <nav className="-mb-px flex space-x-8 "> 
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`py-4 px-1 border-b-2 font-normal text-sm whitespace-nowrap transition-colors ${
                isActive(item.path)
                  ? 'border-blue-500'
                  : 'border-transparent'
              }`}
              style={{
                color: isActive(item.path)
                  ? '#3b82f6'
                  : theme === 'dark' ? '#a1a1aa' : '#6b7280',
                textDecoration: 'none',
              }}
              onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => {
                if (!isActive(item.path)) {
                  e.currentTarget.style.color = theme === 'dark' ? '#d4d4d8' : '#374151';
                }
              }}
              onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => {
                if (!isActive(item.path)) {
                  e.currentTarget.style.color = theme === 'dark' ? '#a1a1aa' : '#6b7280';
                }
              }}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
});

SuperAdminNav.displayName = 'SuperAdminNav';

